import options from './shy.directive';

export default {
    selector: 'imSoShy',
    options
};
